const PROBLEMS = [
  {
    number: '01',
    text: 'Data re-entered by hand across multiple tools or spreadsheets.',
  },
  {
    number: '02',
    text: "Processes that live in one person's head, or one fragile spreadsheet.",
  },
  {
    number: '03',
    text: 'Manual tracking, follow-ups, or reporting that eats hours every week.',
  },
  {
    number: '04',
    text: "Systems that don't talk to each other, so someone bridges the gap by hand.",
  },
];

export function Problem() {
  return (
    <section id="problem" className="bg-bg2 px-6 py-24 transition-colors duration-[450ms]">
      <div className="mx-auto max-w-[1200px]">
        <div className="mb-3.5 flex items-baseline gap-4">
          <span className="text-xs tracking-[0.3em] text-accent">01 — THE PROBLEM</span>
        </div>
        <h2
          data-reveal
          className="m-0 mb-[18px] font-display text-[clamp(30px,3.6vw,46px)] font-semibold tracking-[-0.02em]"
        >
          Sound familiar?
        </h2>
        <p data-reveal className="m-0 mb-[52px] max-w-[560px] text-[16.5px] leading-[1.6] text-dim">
          If any of these are part of your week, there is time being spent that does not need to
          be.
        </p>
        <div className="grid grid-cols-1 gap-[18px] min-[620px]:grid-cols-2 min-[900px]:grid-cols-4">
          {PROBLEMS.map((p) => (
            <div
              key={p.number}
              data-reveal
              className="group rounded-2xl border border-[var(--line)] bg-[var(--card)] px-6 pb-[30px] pt-7 transition-[transform,border-color,background] duration-[350ms] hover:-translate-y-1.5 hover:border-accent/55"
            >
              <div className="mb-[18px] flex h-[34px] w-[34px] items-center justify-center rounded-[9px] border border-accent/40 bg-accent/[0.14] font-display text-sm text-accent">
                {p.number}
              </div>
              <p className="m-0 text-balance text-base leading-[1.55]">{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
